// libs
import { styled } from '@nykaa/ui-components';

//constants
import { BASE_GUTTER_SPACE } from 'shared/styles/base';

export const SearchContainer = styled.div`
  background: ${({ theme }) => theme.colors.surface50};
  border-radius: ${({ theme }) => theme.borders.radius20};
  padding: ${({ theme }) => `${theme.spacing.spacing0} ${theme.spacing.spacing50}`};
  border-bottom: 2px solid transparent;
  &:focus-within {
    border-bottom: 2px solid ${({ theme }) => theme.colors.secondary};
  }
  transition: border-bottom 0.2s ease;
  display: flex;
  align-items: center;
  position: relative;
`;

export const InputSearchIcon = styled.div`
  vertical-align: middle;
  display: inline-flex;
`;

export const CloseIcon = styled.div`
  margin-left: ${({ theme }) => theme.spacing.spacing20};
  vertical-align: middle;
  cursor: pointer;
  position: absolute;
  right: ${BASE_GUTTER_SPACE}px;
  display: inline-flex;
`;

export const InputField = styled.input`
  ${({ theme }) => theme.typography.bodyMedium};
  border-radius: ${({ theme }) => theme.borders.radius35};
  background: transparent;
  padding: ${({ theme }) => theme.spacing.spacing40};
  padding-left: ${({ theme }) => theme.spacing.spacing40};
  border: none;
  outline: none;
  color: ${({ theme }) => theme.colors.textPrimary};
  &::placeholder {
    color: ${({ theme }) => theme.colors.textSecondary};
  }
`;
